// extracted by mini-css-extract-plugin
export var locationCard = "_ow-0";